<template>
  <div>
    <p v-if="row.level == 'campaign'">
      <span v-if="!row.campaign_ref?.opt_info?.opt_id">
        <el-button size="mini" @click="$emit('relate-sale-click', { row })">
          关联商品
        </el-button>
      </span>
      <span v-else>
        <!-- 关联的用户id和单点id一致，没有特殊颜色;关联的用户和单点id不一致，橙色，不让开启 -->
        <el-tag
          :type="
            row.campaign_ref?.opt_info?.opt_id === userInfo.data.id
              ? 'success'
              : 'warning'
          "
        >
          {{ row.campaign_ref?.opt_info?.opt_name }} ({{
            row.campaign_ref?.opt_info?.status ? '在职' : '离职'
          }})
        </el-tag>
      </span>
    </p>
    <div v-else>--</div>
  </div>
</template>

<script>
export default {
  name: 'RelatedProductCell',
  props: {
    row: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  }
}
</script>